import Select from "@mostrans/web-components/components/base/Select";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import React, { useState } from "react";
import { useSetRecoilState } from "recoil";
import { filterKotaforJobsAtom } from "../../shared/globalStates";
import { useGetMasterKota } from "../../shared/hooks/useGetMasterData";

const FilterKota = (props) => {
  const { classes } = props;
  const [listMasterKota] = useGetMasterKota();
  const [active, setActive] = useState();
  const setSelectedKota = useSetRecoilState(filterKotaforJobsAtom);

  const optionsKota = listMasterKota.map((item) => {
    return { value: item.id, label: item.nama };
  });
  return (
    <Accordion
      className={classes.root}
      disableGutters={true}
      defaultExpanded={true}
      style={{ boxShadow: "none", borderRadius: "10px" }}>
      <AccordionSummary classes={{ content: classes.content }} onClick={() => setActive(!active)}>
        <b>Location</b>
        <div>
          {(() => {
            if (active) {
              return <span className="material-icons">expand_less</span>;
            } else {
              return <span className="material-icons">expand_more</span>;
            }
          })()}
        </div>
      </AccordionSummary>
      <AccordionDetails sx={{ padding: "2rem 1rem" }}>
        {(() => {
          if (!!optionsKota) {
            return (
              <Select
                isClearable
                placeholder="City"
                options={optionsKota}
                onChange={(e) => (!e ? setSelectedKota(null) : setSelectedKota(e.label))}
              />
            );
          } else {
            return null;
          }
        })()}
      </AccordionDetails>
    </Accordion>
  );
};

export default FilterKota;
